import React, { useEffect, useState } from "react";
import '../../../styles/testimonial.css';
const testimonials = [
  {
    id: 1,
    quote: "Shaheer and the INVESTA ESTATES team made buying in Istanbul seamless — from the first viewing to receiving our title deed. Exceptional service for international buyers.",
    author: "Ahmed Al-Rashidi, Dubai"
  },
  
];

const ClientMessages: React.FC = () => {
    const [activeIndex, setActiveIndex] = useState(0);
     // Auto-slide every 5 seconds
    useEffect(() => {
        const interval = setInterval(() => {
        setActiveIndex((prev) => (prev + 1) % testimonials.length);
        }, 5000);
        return () => clearInterval(interval);
    }, []);
    return (
         <section id="testimonials">
            <div className="container">
            <div className="section-label">Client Voices</div>
            {testimonials.map((testimonial, index) => (
                <div key={testimonial.id} className={`testimonial ${index === activeIndex ? 'active' : ''}`}>
                <div className="testimonial-quote">{testimonial.quote}</div>
                <div className="testimonial-author">{testimonial.author}</div>
                </div>
            ))}
           
            <div className="testimonial-dots">
                {testimonials.map((_, index) => (
                    <button
                    key={index}
                    className={`dot ${index === activeIndex ? 'active' : ''}`}
                    onClick={() => setActiveIndex(index)}
                    aria-label={`Go to slide ${index + 1}`}
                    />
                ))}
            </div>
            </div>
        </section>
    )
}

export default ClientMessages;